import { useEffect } from "react";
import Emitter from "./EventEmitter";
export default function useEventSubscription(event, fn) {
    useEffect(() => {
        Emitter.on(event, fn);
        return () => {
            Emitter.off(event, fn);
        };
    }, [event, fn]);
}
